import Component from 'gia/Component';
import { gsap } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(TextPlugin);


export default class CrtText extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      text1: {},
      text2: {},
    };
  }

  mount() {
    let that = this;

    let timeline = gsap.timeline();
    timeline.to(this.ref.text1, {
      duration: 2,
      text: {
        value: "Track the progress of Brighton & Hove schools becoming fully smartphone-free.",
        padSpace: false
      },
      ease: "none",
    });


    timeline.to(this.ref.text2, {
      duration: 2,
      text: {
        value: "Fully smartphone-free means only brick phones are allowed on site.",
        padSpace: false
      },
      ease: "none",
    });


  }


}